import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'
import { Popup, Header, Title, Body, Footer } from '@calendly/ui/components/popup'

export const LeaveWithoutPublishingPopup = ({
  isOpen,
  onClose,
  onDiscard,
  onContinueEditing
}) => (
  <Popup
    isOpen={isOpen}
    onClose={onClose}
    withCloseButton
  >
    <Header>
      <Title>
        {I18n.t('publisher.event_type_editor.sections.more_options.notifications.leave_without_publishing.title')}
      </Title>
    </Header>
    <Body>
      {I18n.t('publisher.event_type_editor.sections.more_options.notifications.leave_without_publishing.body')}
    </Body>
    <Footer>
      <Button
        decoration="secondary-danger"
        onClick={onDiscard}
        data-testid="leave-without-publishing-discard"
      >
        {I18n.t('publisher.event_type_editor.sections.more_options.notifications.leave_without_publishing.discard_and_leave')}
      </Button>
      <Button
        onClick={onContinueEditing}
        data-testid="leave-without-publishing-continue"
      >
        {I18n.t('publisher.event_type_editor.sections.more_options.notifications.leave_without_publishing.continue_editing')}
      </Button>
    </Footer>
  </Popup>
)
